"use strict";
var wellKnownSymbol = require("../internals/well-known-symbol");
var Iterators = require("../internals/iterators");
var ITERATOR = wellKnownSymbol("iterator");
var ArrayPrototype = Array.prototype;
module.exports = function(it) {
  return it !== void 0 && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};
